export const scoreboardTools = [
  {
    id: "jcl-9",
    title: "JCL 9ボール",
    description: "ラックの勝者と相手の入球数を選ぶだけ。持ち点まで自動で集計。",
    href: "/scoreboards/jcl-9",
    action: "スコアボードを開く",
  },
  {
    id: "jcl-8",
    title: "JCL 8ボール",
    description: "勝者14点と相手の入球数を、ラックごとにまとめて記録。",
    href: "/scoreboards/jcl-8",
    action: "スコアボードを開く",
  },
  {
    id: "jpa-9",
    title: "JPA 9ボール",
    description: "入れた球をタップ。持ち点・無効球・イニングをまとめて記録。",
    href: "/scoreboards/jpa-9",
    action: "スコアボードを開く",
  },
  {
    id: "jpa-8",
    title: "JPA 8ボール",
    description: "2人のSLから先取数を設定。ラックの勝者を選んで記録。",
    href: "/scoreboards/jpa-8",
    action: "スコアボードを開く",
  },
  {
    id: "straight",
    title: "14-1",
    description:
      "入球数をまとめて加点。ランとファウル、ラックをまたぐ得点を記録。",
    href: "/scoreboards/straight",
    action: "スコアボードを開く",
  },
  {
    id: "five-nine",
    title: "5-9",
    description:
      "点球とサイドを記録して、全員の差し引きを自動集計。2〜6人対応。",
    href: "/scoreboards/five-nine",
    action: "スコアボードを開く",
  },
  {
    id: "rotation",
    title: "ローテーション",
    description:
      "入れた球の番号をタップして加点。個別の持ち点と残球を見やすく。",
    href: "/scoreboards/rotation",
    action: "スコアボードを開く",
  },
  {
    id: "carom",
    title: "スリークッション",
    description: "得点と手番を記録。平均・最高ラン、イコールイニングに対応。",
    href: "/scoreboards/carom",
    action: "スコアボードを開く",
  },
  {
    id: "snooker",
    title: "スヌーカー",
    description: "球の色で加点。ファウル点・フレーム先取、15／6レッドに対応。",
    href: "/scoreboards/snooker",
    action: "スコアボードを開く",
  },
] as const;
